import client from "./axiosConfig";

export const getSites = (params) => {
  const config = {
    url: "/users/site",
    method: "GET",
    params
  };
  const response = client(config);
  return response;
};

export const getSiteById = (id) => {
  const config = {
    url: `/users/site/${id}/`,
    method: "GET",
  };
  const response = client(config);
  return response;
};

export const deleteSiteById = (id) => {
  const config = {
    url: `/users/site/${id}/`,
    method: "DELETE",
  };
  const response = client(config);
  return response;
};

export const updateSiteById = (id, payload) => {
  const config = {
    url: `/users/site/${id}/`,
    method: "PATCH",
    data: payload,
  };
  return client(config);
};

export const postSites = (data) => {
  const config = {
    url: "/users/site/",
    method: "POST",
    data
  };
  const response = client(config);
  return response;
};